import styled, { css } from 'styled-components'
import { getSearchInputStyles } from '../Search/Search.styles'
import { colors } from '../_styles/colors'
import { spacing } from '../_styles/spacing'

const inputHeight = 36

export const StyledInput = styled.input<{ $hasValue?: boolean }>`
  ${getSearchInputStyles()}

  padding-left: ${spacing.xxl}px;
  padding-right: ${(p) => (p.$hasValue ? spacing.xxl : spacing.md)}px;
`

const iconContainerStyles = css<{ disabled?: boolean }>`
  align-items: center;
  color: ${(p) => (p.disabled ? colors.gray70 : colors.gray45)};
  display: flex;
  height: ${inputHeight}px;
  justify-content: center;
  position: absolute;
  top: 0;
  width: ${inputHeight}px;
`

export const StyledSearchIcon = styled.div<{ disabled?: boolean }>`
  ${iconContainerStyles}
  left: 0;
  pointer-events: none;
`

export const StyledClearIcon = styled.div<{ disabled?: boolean }>`
  ${iconContainerStyles}
  pointer-events: ${(p) => (p.disabled ? 'none' : 'auto')};
  right: 0;
`

export const StyledTypeahead = styled.div`
  position: relative;
  width: 100%;
`
